import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';

import type { HydrateAction } from '../actions';
import { replaceByUuid } from '../utils';

import {
  notificationsRequestAction,
  setFilter,
  toggleDrawer,
  updateNotificationReadAction,
} from './actions';
import { NotificationFilter } from './types';
import type { NotificationAction, NotificationState } from './types';

export const notificationInitialState: NotificationState = {
  drawerVisible: false,
  filter: NotificationFilter.UNREAD,
  rows: [],
};

export const notificationReducer = createReducer<
  NotificationState,
  NotificationAction | HydrateAction
>(notificationInitialState)
  .handleAction(notificationsRequestAction.success, (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.rows = payload;
    })
  )
  .handleAction(
    updateNotificationReadAction.success,
    (state, { payload: notifications }) =>
      produce(state, (draftState) => {
        draftState.rows = replaceByUuid(state.rows, notifications);
      })
  )
  .handleAction(setFilter, (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.filter = payload;
    })
  )
  .handleAction(toggleDrawer, (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.drawerVisible = payload.visible;
      draftState.filter = payload.filter ?? state.filter;
    })
  );
